<template>
  <div id="app" class="min-vh-100 d-flex flex-column">
    <header class="bg-orange-dark text-white py-3 px-4">
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <h1 class="m-0 text-center text-md-start">Olympic Appliance Service</h1>
        <div class="mt-3 mt-md-0 d-flex align-items-center gap-2">
          <!-- Phone Number (desktop only) -->
          <span class="text-white me-2 d-none d-md-inline fw-semibold fs-5">
            (360) 490-1903
          </span>

          <!-- Call Button -->
          <a href="tel:13604901903" class="rounded-circle icon-btn" title="Call">
            <i class="bi bi-telephone-fill"></i>
          </a>

          <!-- Email Button -->
          <a href="mailto:olympicappliance@gmail.com" class="rounded-circle icon-btn" title="Email">
            <i class="bi bi-envelope-fill"></i>
          </a>
        </div>
      </div>
    </header>

    <main class="flex-fill container py-5">
      <section class="row bg-white bg-opacity-75 p-4 rounded shadow align-items-stretch">

        <div class="col-md-4 d-flex flex-column align-items-center text-center order-2 order-md-0 mt-4 mt-md-0">
          <img src="@/assets/profile.png" alt="Technician Profile" class="img-fluid rounded shadow-sm mb-3" />
          <p class="fs-3 fw-semibold mb-0 d-none d-md-block">Martin Foshaug</p>

          <!-- Mobile "Serving..." message -->
          <p class="fs-3 fw-semibold d-md-none mt-3">Martin Foshaug</p>
          <p class="fs-5 fw-semibold d-md-none mt-3">Serving the Olympia Area for over 15 years</p>
        </div>


        <!-- Text Column (stretch full height) -->
        <!-- Text Column -->
        <div
          class="col-12 col-md-8 d-flex flex-column justify-content-between text-center text-md-start order-0 order-md-1">

          <!-- Flat Rate Content (TOP) -->
          <div>
            <h2 class="display-6 display-md-5 fw-bold mb-3">Flat Rate</h2>
            <p class="fs-4 fs-md-3 fw-semibold mb-2"><b>$149</b> plus cost of parts.</p>
            <p class="fs-5 fs-md-3 fw-semibold mb-0">
              This covers the whole repair,
              <span class="d-block d-md-inline">start to finish!</span>
            </p>
          </div>

          <!-- 🔔 Call Us Section -->
          <section class="text-center py-5">
            <h2 class="display-6 display-md-5 fw-bold mb-4">Call Us</h2>

            <div class="d-flex justify-content-center align-items-center flex-wrap gap-3">
              <p class="fs-3 fw-semibold m-0">1 (360) 490-1903</p>
              <a href="tel:13604901903" class="rounded-circle icon-btn" title="Call Now">
                <i class="bi bi-telephone-fill"></i>
              </a>
            </div>
          </section>


          <!-- Desktop "Serving..." message (BOTTOM) -->
          <div class="text-md-end d-none d-md-block">
            <p class="fs-3 fw-semibold mb-0">Servicing the Olympia Area</p>
            <p class="fs-3 fw-semibold mb-0">for over 15 years</p>
          </div>

        </div>



      </section>
      <!-- 🔹 About Section -->
      <section class="container py-5">
        <h2 class="display-6 fw-bold mb-4 text-center">About Olympic Appliance Service</h2>
        <p class="fs-5 text-center">
          Olympic Appliance Service is a family-owned business committed to delivering the highest quality appliance
          repair.
          We are proud to serve Thurston County with quality workmanship and great customer service.
          We are a mobile company that services washers, dryers, ranges, cooktops, ovens, disposals, refrigerators,
          freezers,
          trash compactors, and dishwashers.
        </p>
        <p class="fs-5 text-center">
          Feel free to call Martin anytime at <strong>360-490-1903</strong>.
        </p>
      </section>

      <!-- 🔹 Guarantees & Services -->
      <section class="container py-5">
        <h2 class="display-6 fw-bold mb-4 text-center">Why Choose Us</h2>
        <ul class="fs-5 list-unstyled text-center">
          <li>
            <span aria-hidden="true" class="me-2">✔️</span>
            Parts and labor guarantee
          </li>
          <li>
            <span aria-hidden="true" class="me-2">✔️</span>
            Repairs most makes and models
          </li>
          <li>
            <span aria-hidden="true" class="me-2">✔️</span>
            Licensed and insured
          </li>
          <li>
            <span aria-hidden="true" class="me-2">✔️</span>
            Exceptional service
          </li>
        </ul>
      </section>

      <section class="container py-5">
        <h2 class="display-6 fw-bold mb-4 text-center">Brands We Service</h2>
        <div class="row fs-6 text-center justify-content-center">
          <div class="col-6 col-md-3"><strong>Amana</strong></div>
          <div class="col-6 col-md-3"><strong>Bosch</strong></div>
          <div class="col-6 col-md-3"><strong>Electrolux</strong></div>
          <div class="col-6 col-md-3"><strong>Frigidaire</strong></div>
          <div class="col-6 col-md-3"><strong>Gaggenau</strong></div>
          <div class="col-6 col-md-3"><strong>GE / General Electric</strong></div>
          <div class="col-6 col-md-3"><strong>HotPoint</strong></div>
          <div class="col-6 col-md-3"><strong>Jenn-Air</strong></div>
          <div class="col-6 col-md-3"><strong>Kenmore</strong></div>
          <div class="col-6 col-md-3"><strong>KitchenAid</strong></div>
          <div class="col-6 col-md-3"><strong>LG</strong></div>
          <div class="col-6 col-md-3"><strong>Magic Chef</strong></div>
          <div class="col-6 col-md-3"><strong>Maytag</strong></div>
          <div class="col-6 col-md-3"><strong>Roper</strong></div>
          <div class="col-6 col-md-3"><strong>Samsung</strong></div>
          <div class="col-6 col-md-3"><strong>Siemens</strong></div>
          <div class="col-6 col-md-3"><strong>Speed Queen</strong></div>
          <div class="col-6 col-md-3"><strong>Tappan</strong></div>
          <div class="col-6 col-md-3"><strong>Thermador</strong></div>
          <div class="col-6 col-md-3"><strong>Viking</strong></div>
          <div class="col-6 col-md-3"><strong>Westinghouse</strong></div>
          <div class="col-6 col-md-3"><strong>Whirlpool</strong></div>
          <div class="col-6 col-md-3"><strong>White-Westinghouse</strong></div>
          <div class="col-6 col-md-3"><strong>Wolf</strong></div>
        </div>
        <p class="fs-5 text-center mt-4">
          If your brand is not listed, <strong>please call us</strong> - we can probably repair it too!
        </p>
      </section>


      <!-- 🔹 Pricing Info -->
      <section class="container py-5">
        <h2 class="display-6 fw-bold mb-4 text-center">Transparent, Flat Rate Pricing</h2>
        <p class="fs-5 text-center">
          We want to help you save money by repairing rather than replacing your appliances.
          Olympic Appliance Service utilizes flat rate pricing, so you save more than with competitors who charge by the
          hour.
        </p>
        <ul class="fs-5 list-unstyled text-center">
          <ul class="fs-5 list-unstyled text-center">
            <li>
              <span aria-hidden="true" class="me-2">✔️</span>
              No hidden fees
            </li>
            <li>
              <span aria-hidden="true" class="me-2">✔️</span>
              No mileage charge
            </li>
            <li>
              <span aria-hidden="true" class="me-2">✔️</span>
              No shipping charge
            </li>
            <li>
              <span aria-hidden="true" class="me-2">✔️</span>
              No return trip charge
            </li>
            <li>
              <span aria-hidden="true" class="me-2">✔️</span>
              No fuel surcharges
            </li>
          </ul>
        </ul>
        <p class="fs-5 text-center mt-3">
          Call <strong>Martin at 360-490-1903</strong> for more information on flat rate pricing.
        </p>
      </section>

      <section class="container py-5">
        <h2 class="display-6 fw-bold mb-4 text-center">What Our Customers Say</h2>

        <div class="position-relative mx-auto bg-white rounded shadow p-4 review-box"
          style="max-width: 700px; overflow: visible;">
          <!-- Left Button -->
          <button class="rounded-circle icon-btn position-absolute top-50 translate-middle-y"
            style="left: 0; z-index: 10;" @click="prevReview" aria-label="Previous Review">
            <i class="bi bi-chevron-left"></i>
          </button>

          <!-- Review Content -->
          <div class="text-center px-5 w-100" :key="currentReviewIndex">
            <p class="review-text fst-italic mb-3">"{{ reviews[currentReviewIndex].text }}"</p>
            <p class="fw-semibold mb-0">{{ reviews[currentReviewIndex].author }}</p>
          </div>

          <!-- Right Button -->
          <button class="rounded-circle icon-btn position-absolute top-50 translate-middle-y"
            style="right: 0; z-index: 10;" @click="nextReview" aria-label="Next Review">
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </section>

      <section class="container py-5 text-center">
        <h2 class="display-6 fw-bold mb-3">Can't call right now?</h2>
        <p class="fs-5">
          Send us an email at:
          <a href="mailto:olympicappliance@gmail.com" class="fw-semibold text-decoration-none text-dark">
            olympicappliance@gmail.com
          </a>
        </p>
      </section>




    </main>




  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      reviews: [
        {
          text: "If I could give Martin 6 stars, I absolutely would. This guy showed up at my house promptly at the time we discussed and got right to work trying to solve my issue. Ultimately, he determined that my machine needed a part that Samsung no longer makes and gave me his fair and educated opinion on my best way forward. Where I’m sure many businesses would have happily sold me additional services at high rates, Martin’s pricing is (in my opinion) beyond fair and very hard to beat. Definitely recommend Olympic Appliance Service to anyone that is having issues with their appliances.",
          author: "Troy Hokanson"
        },
        {
          text: "Martin was quick to respond, knowledgeable and helped me get on the right path to repairing my fridge. He didn't push a sale etc, just tried to help. Will be calling Martin next time in a jam. Thanks!",
          author: "Robert Hardy"
        },
        {
          text: "Martin could hear the panic in my voice going into the weekend with the prospect of not having a dryer for the mountains of laundry my family seems to produce. He made time for me on a Friday that I know he was looking forward to being off early. I appreciate that type of service. I also didn’t know if I should just buy a new one or have it repaired. He talked me out of the new purchase. Diagnosed and fixed the problem in minutes. Thank you for saving me hundreds. Call Olympic Appliance Service for your appliance fixes before you get rid of them. Martin will treat you right. Thank you, Martin!!",
          author: "Donald J. Weathers"
        },
        {
          text: "Great guy, honest friendly and he does a great job. Just his experience alone with symptoms he diagnosed the problem quickly and fixed them right then!",
          author: "Timothy Hood"
        },
        {
          text: "Texted Martin about our dryer needing repair and he came out the next day. Didn't have the parts needed but did a temporary repair so we could still use it in the days waiting for the new parts to come in. Price was very reasonable too! He came recommended by a neighbor and I'll definitely continue the recommendation. He'll absolutely get our business again should we need it!",
          author: "Jillian D."
        },
        {
          text: "Very efficient and extremely nice. Martin was in and out in under an hour. He fixed my dryer and didn't charge me the cost of a new one. Will definitely be using this service again.",
          author: "Daniel F."
        },
      ],
      currentReviewIndex: 0,
      autoAdvanceInterval: null
    };

  },
  methods: {
    nextReview() {
      this.currentReviewIndex = (this.currentReviewIndex + 1) % this.reviews.length;
    },
    prevReview() {
      this.currentReviewIndex =
        (this.currentReviewIndex - 1 + this.reviews.length) % this.reviews.length;
    },
    startAutoAdvance() {
      if (!this.autoAdvanceInterval) {
        this.autoAdvanceInterval = setInterval(this.nextReview, 7000);
      }
    },
    stopAutoAdvance() {
      clearInterval(this.autoAdvanceInterval);
    },
  },
  mounted() {
    this.startAutoAdvance();
  },
  beforeUnmount() {
    this.stopAutoAdvance();
  },
};

</script>

<style>
@font-face {
  font-family: 'Limelight';
  src: url('@/assets/fonts/Limelight-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}



.review-box {
  height: 500px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

@media (max-width: 767.98px) {
  .review-box {
    height: 650px;
  }
}

.review-text {
  font-size: 1.25rem;
  /* equivalent to Bootstrap fs-5 */
  line-height: 1.6;
}

@media (max-width: 767.98px) {
  .review-text {
    font-size: 1rem;
  }
}



.icon-btn+.icon-btn {
  margin-left: 15px;
}

/* Optional: smooth transition effect */
.review-box {
  transition: opacity 0.4s ease;
}


header h1 {
  font-family: 'Limelight', sans-serif;
  font-size: 2.5rem;
  letter-spacing: 1px;
}

.bg-orange-dark {
  background-color: #853500;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #ffe9d4;
}

.icon-btn {
  background-color: #ffe9d4;
  color: #2c3e50;
  border: none;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s ease;
}

.icon-btn i {
  font-size: 1.5rem;
  /* or 1.75rem, 2rem, etc. */
}

.icon-btn:hover {
  background-color: #ffd9b3;
}


.gap-2 {
  gap: 0.5rem;
}
</style>
